import { render } from "./CreateCard.vue?vue&type=template&id=1a58ee9a&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=js"
export * from "./CreateCard.vue?vue&type=script&lang=js"

import "./CreateCard.vue?vue&type=style&index=0&id=1a58ee9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a58ee9a"]])

export default __exports__